<template>

    <div class="fixed-comment-form-wrapper"
         @keydown.down="handleKey($event, 'down')"
         @keydown.up="handleKey($event, 'up')"
         @keydown.enter="handleKey($event, 'enter')"
         id="comment-form">

        <div v-if="preview && message"
             class="form-wrapper margin-bottom-1 preview">
            <markdown :text="message.trim()"></markdown>
        </div>


        <form class="chat-input-form relative" style="border: none; max-width:750px;">

            <div class="ckeditor-wrap">
                <CKEditorComponent
                        @input="input"
                        :height="'80%'"
                        v-model="message"
                >
                </CKEditorComponent>
                <el-tooltip content="Use it only If your comment is 100+ words and is serious" placement="bottom" transition="false" :open-delay="400">                
                <el-checkbox v-if="showSeriousButton" v-model="isWritingSeriousComment" style="margin: 7px;">Serious</el-checkbox>
                </el-tooltip>

                <button :class="{ 'go-white': message.trim(), 'btn primary-btn float-right':true }"
                        @click="submit($event)">
                    Publish
                    <el-tooltip placement="bottom-end"
                                transition="false"
                                v-show="!loading">
                        <div slot="content">
                            Press to comment
                        </div>
                        <!--  <i class="v-icon v-send" aria-hidden="true"></i> -->
                    </el-tooltip>

                    <moon-loader :loading="loading"
                                 :size="'25px'"
                                 :color="'#fff'"
                                 :style="'margin:auto;width: 25px;'">
                    </moon-loader>
                </button>

                <button class="btn warning-btn float-right" style="    margin-right: 5px; background: none; color: #3d3d3d;" @click="cancel" v-if="actionType !== 'create'">
                    Cancel
                </button>
            </div>
        </form>
    </div>
</template>

<script>
    import Markdown from '../components/Markdown.vue'
    import MoonLoader from '../components/MoonLoader.vue'
    import EmojiPicker from '../components/EmojiPicker.vue'
    import QuickEmojiPicker from '../components/QuickEmojiPicker.vue'
    import QuickChannelPicker from '../components/QuickChannelPicker.vue'
    import QuickMentioner from '../components/QuickMentioner.vue'
    import EmojiIcon from '../components/Icons/EmojiIcon.vue'
    import Typing from '../components/Typing.vue'
    import Helpers from '../mixins/Helpers'
    import InputHelpers from '../mixins/InputHelpers'
    import CKEditorComponent from './CKEditor'

    export default {
        components: {
            CKEditorComponent,
            QuickChannelPicker,
            QuickEmojiPicker,
            QuickMentioner,
            MoonLoader,
            EmojiPicker,
            EmojiIcon,
            Markdown,
            Typing
        },

        props: ['submission', 'before', 'commentors', 'activeComment', 'actionType', 'showSeriousButton', 'currentCommentId'],

        mixins: [Helpers, InputHelpers],

        data() {
            return {
                emojiPicker: false,
                loading: false,
                message: '',
                temp: '',
                mentioning: false,
                EchoChannelAddress: 'submission.' + this.$route.params.slug,
                isTyping: false,
                preview: false,

                quickMentioner: {
                    show: false,
                    starter: null
                },

                quickEmojiPicker: {
                    show: false,
                    starter: null
                },

                quickChannelPicker: {
                    show: false,
                    starter: null
                },
                activeName: 'first',

                editingComment: [],
                replyingComment: [],
                parent: 0,
                isWritingSeriousComment: false,
                type: 'relaxed'
            }
        },

        created() {

            // this.$eventHub.$on('edit-comment', this.setEditing);
            // this.$eventHub.$on('reply-comment', this.setReplying);

            if (this.actionType === 'reply') {
                this.setReplying(this.activeComment)
            }

            if (this.actionType === 'edit') {
                this.setEditing(this.activeComment)
            }

            this.subscribeToEcho()
            this.$eventHub.$on('pressed-esc', this.handleEscapteKeyup)
        },

        beforeDestroy() {
            // this.$eventHub.$off('edit-comment', this.setEditing);
            // this.$eventHub.$off('reply-comment', this.setReplying);
            this.$eventHub.$off('pressed-esc', this.handleEscapteKeyup)
        },

        watch: {
            $route() {
                this.clear()
            },
        },

        computed: {
            replying() {
                return !_.isEmpty(this.replyingComment)
            },

            editing() {
                return !_.isEmpty(this.editingComment)
            },

            showSubmit() {
                return this.loading == false && this.message.trim()
            }
        },

        methods: {
            input(val) {
                this.message = val
            },
            typed(string) {
                // close on empty input
                if (!string.trim()) {
                    this.quickMentioner.show = false
                    this.quickEmojiPicker.show = false
                    this.quickChannelPicker.show = false
                    return
                }

                // get the last typed character (but not the last character of the string)
                let lastStrIndex = this.lastTypedCharacter('comment-form-textarea')
                let lastStr = string[lastStrIndex]
                // let previousStr = string[lastStrIndex - 1];

                // close on space
                if (lastStr == ' ') {
                    this.quickMentioner.show = false
                    this.quickEmojiPicker.show = false
                    this.quickChannelPicker.show = false
                    return
                }

                // previous must be empty space to continue
                // if (previousStr != ' ' && string.length > 1) return;

                if (lastStr == '@') {
                    this.quickMentioner.show = true
                    this.quickMentioner.starter = lastStrIndex

                    this.quickEmojiPicker.show = false
                    this.quickChannelPicker.show = false
                } else if (lastStr == ':') {
                    this.quickEmojiPicker.show = true
                    this.quickEmojiPicker.starter = lastStrIndex

                    this.quickMentioner.show = false
                    this.quickChannelPicker.show = false
                } else if (lastStr == '#') {
                    this.quickChannelPicker.show = true
                    this.quickChannelPicker.starter = lastStrIndex

                    this.quickEmojiPicker.show = false
                    this.quickMentioner.show = false
                }
            },

            /**
             * Subscribes to the Echo channel. Prepares comment form for whispering "typing".
             *
             * @return void
             */
            subscribeToEcho() {
                if (this.isGuest) return

                Echo.private(this.EchoChannelAddress)
            },

            /**
             * Broadcast "typing".
             *
             * @return void
             */
            whisperTyping() {
                if (this.isGuest) return

                if (this.isTyping) return

                if (this.editing) return

                Echo.private(this.EchoChannelAddress).whisper('typing', {
                    username: auth.username
                })

                this.isTyping = true
            },

            /**
             * Broadcast "finished-typing".
             *
             * @return void
             */
            whisperFinishedTyping: _.debounce(function () {
                if (this.isGuest) return

                Echo.private(this.EchoChannelAddress).whisper('finished-typing', {
                    username: auth.username
                })

                this.isTyping = false
            }, 600),

            handleKey(event, key) {
                if (
                    !this.quickEmojiPicker.show &&
                    !this.quickMentioner.show &&
                    !this.quickChannelPicker.show
                )
                    return

                event.preventDefault()

                this.$eventHub.$emit('keyup:' + key)
            },

            setEditing(comment) {
                this.clear()
                this.editingComment = comment
                this.message = comment && comment.content ? comment.content.text : null
                this.parent = comment.parent_id
                // this.$refs.input.focus();
            },

            setReplying(comment) {
                this.clear()
                if (!!comment) {
                    this.replyingComment = comment
                    this.parent = this.replyingComment.id
                } else {
                    this.replyingComment = null
                    this.parent = 0
                }
                // this.$refs.input.focus();
            },

            handleEscapteKeyup() {
                if (this.quickEmojiPicker.show) {
                    this.quickEmojiPicker.show = false
                } else if (this.quickMentioner.show) {
                    this.quickMentioner.show = false
                } else if (this.quickChannelPicker.show) {
                    this.quickChannelPicker.show = false
                } else {
                    if (
                        !_.isEmpty(this.editingComment) ||
                        !_.isEmpty(this.replyingComment)
                    ) {
                        this.clear()
                    }
                }
            },

            /**
             * Like it never happened!
             *
             * @return void
             */
            clear() {
                this.isWritingSeriousComment = false
                this.editingComment = []
                this.replyingComment = []
                this.message = '';
                this.temp = '';
                this.loading = false
                this.preview = false
                this.parent = 0
            },

            pick(pickedStr, starterIndex, typedLength) {
                this.insertPickedItem(
                    'comment-form-textarea',
                    pickedStr + ' ',
                    starterIndex,
                    typedLength
                )
            },

            openEmojiPicker() {
                this.emojiPicker = true
            },

            closeEmojiPicker() {
                this.emojiPicker = false
            },

            submit(event) {
                event.preventDefault()
                // ignore if any quick pciking box is open
                // if (
                //     this.quickEmojiPicker.show ||
                //     this.quickMentioner.show ||
                //     this.quickChannelPicker.show ||
                //     !this.message.trim()
                // )
                //     return;
                //
                // this.closeEmojiPicker();

                if (this.isGuest) {
                    this.mustBeLogin()
                    return
                }

                this.temp = this.message

                // this.message = '';
                this.loading = true

                // we're editing, not posting a new comment
                if (this.editing) {
                    if (this.temp == this.before) {
                        this.message = this.temp
                        this.loading = false
                        this.$eventHub.$emit('patchedComment', this.editingComment)
                        return
                    }

                    this.patchComment()
                    return
                }
                // new comment
                this.postComment()
            },

            cancel() {
                this.$eventHub.$emit('cancelComment', null)
            },

            patchComment() {
                axios
                    .patch(`/comments/${this.editingComment.id}`, {
                        body: this.temp
                    })
                    .then(() => {
                        this.editingComment.content.text = this.temp
                        this.$eventHub.$emit('patchedComment', this.editingComment)
                        this.loading = false
                        this.clear()
                    })
                    .catch((error) => {
                        this.loading = false
                        // this.message = this.temp;
                    })
            },

            postComment() {
                axios
                    .post(`/submissions/${this.submission}/comments`, {
                        parent_id: this.parent,
                        body: this.temp,
                        type: this.isWritingSeriousComment ? 'serious' : 'relaxed',

                    })
                    .then((response) => {
                        this.$eventHub.$emit('newComment', response.data.data)
                        this.loading = false
                        this.clear()
                    })
                    .catch((error) => {
                        this.loading = false
                    })
            }
        },

        mounted() {
            if (this.activeComment) {
                this.parent = this.activeComment.id;
            }
        }
    }
</script>

<style scoped>
    .submit-btn {
        background: #5587d7;
        color: white;
        float: right;
        padding: 5px 15px;
        margin: 7px;
        border-radius: 3px;
        position: relative;
        bottom: 42px;
        display: inline-block;
        margin-bottom: -35px;
    }

    .float-right {
        float: right;
    }

    .btn {
        background: rgba(36, 121, 255, 0.25);
        border-radius: 3px;
        color: whitesmoke;
        font-size: 14px;
        width: 88px;
        margin-top: 5px;
        margin-bottom: 5px;
        padding: 5px;
    }

    .primary-btn {
        background: rgb(36, 121, 255);
    }

    .warning-btn {
        background: #e0a800;
        color: #000000
    }

</style>



// WEBPACK FOOTER //
// resources/assets/js/components/CommentForm.vue